import { render, staticRenderFns } from "./serviceArea.vue?vue&type=template&id=68f19e52&scoped=true&"
import script from "./serviceArea.vue?vue&type=script&lang=js&"
export * from "./serviceArea.vue?vue&type=script&lang=js&"
import style0 from "./serviceArea.vue?vue&type=style&index=0&id=68f19e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f19e52",
  null
  
)

export default component.exports